import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { Complaint, InProgress, Resolved, Unresolved } from "../../../Constant";
import { Link } from "react-router-dom";
import "../../Dashboard/Default/DashboardStatCard.scss";

const ComplaintDetails = (props) => {
    const value = props.data || {};

    const ComplaintData = [
        {
            id: 1,
            title: Complaint,
            link: `${process.env.PUBLIC_URL}/service-request`,
            count: value.total,
            tone: 'primary',
            icon: 'icofont icofont-support',
        },
        {
            id: 2,
            title: Resolved,
            link: `${process.env.PUBLIC_URL}/service-request?status=closed`,
            count: value.resolved,
            tone: 'success',
            icon: 'icofont icofont-check-circled',
        },
        {
            id: 3,
            title: InProgress,
            link: `${process.env.PUBLIC_URL}/service-request?status=in_progress`,
            count: value.in_process,
            tone: 'warning',
            icon: 'icofont icofont-clock-time',
        },
        {
            id: 4,
            title: Unresolved,
            link: `${process.env.PUBLIC_URL}/service-request?status=open`,
            count: value.un_resolved,
            tone: 'danger',
            icon: 'icofont icofont-close-circled',
        },
    ]

    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="dash-stats">
                    <CardHeader className="pb-0">
                        <H3>{'Service Request Details'}</H3>
                    </CardHeader>

                    <CardBody>
                        <div className="dash-stats__grid">
                            {ComplaintData.map((data) => {
                                const count = data.count ?? 0;
                                return (
                                    <Link
                                        key={data.id}
                                        to={data.link}
                                        className={`dash-stat dash-stat--${data.tone}`}
                                        aria-label={`${data.title}: ${count}`}
                                    >
                                        <div className="dash-stat__main">
                                            <span className="dash-stat__icon" aria-hidden="true">
                                                <i className={data.icon}></i>
                                            </span>
                                            <div className="dash-stat__body">
                                                <span className="dash-stat__label">{data.title}</span>
                                                <span className="dash-stat__value" title={`${count}`}>
                                                    {count}
                                                </span>
                                            </div>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default ComplaintDetails;
